/**
 * Actie per productpagina (lopende actie) — bron voor winkelwagen-kortingscode.
 */
(function (w) {
  'use strict';

  var REGISTRY_KEY = 'uf_product_actie_map';
  var PROP_KEYS = ['Actiecode', 'actiecode', '_uf_actie_code', 'Actie'];

  function getActiveActieCode() {
    if (!w.UF_LF_ACTIE || typeof w.UF_LF_ACTIE.findState !== 'function') return '';
    var state = w.UF_LF_ACTIE.findState(new Date());
    if (!state || state.mode !== 'active' || !state.entry || !state.entry.name) return '';
    return String(state.entry.name).trim();
  }

  function readRegistry() {
    try {
      var raw = w.localStorage.getItem(REGISTRY_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function writeRegistry(map) {
    try {
      w.localStorage.setItem(REGISTRY_KEY, JSON.stringify(map || {}));
    } catch (e) {
      /* ignore */
    }
  }

  function registerProduct(productId, handle, code) {
    code = String(code || '').trim();
    if (!productId || !code) return;
    var map = readRegistry();
    map[String(productId)] = {
      code: code,
      handle: handle || '',
      ts: Date.now()
    };
    writeRegistry(map);
  }

  function getActieFromLineItem(item) {
    if (!item || !item.properties) return '';
    var props = item.properties;
    var i;
    for (i = 0; i < PROP_KEYS.length; i++) {
      var val = props[PROP_KEYS[i]];
      if (val != null && String(val).trim() !== '') return String(val).trim();
    }
    return '';
  }

  function getServerCartActie(productId) {
    var map = w.UF_CART_PRODUCT_ACTIES;
    if (!map || !productId) return '';
    var val = map[String(productId)];
    return val != null ? String(val).trim() : '';
  }

  function getDataActieFromRoot(root) {
    if (!root) return '';
    return String(root.getAttribute('data-uf-lf-actie-code') || '').trim();
  }

  /** Unieke actiecodes afkomstig van producten in de winkelwagen. */
  function resolveCandidatesFromCart(cart) {
    var seen = {};
    var list = [];

    function add(code) {
      code = String(code || '').trim();
      if (!code) return;
      var key = code.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      list.push(code);
    }

    if (!cart || !cart.items || !cart.items.length) return list;

    var registry = readRegistry();

    cart.items.forEach(function (item) {
      var code = getActieFromLineItem(item);
      if (code) {
        add(code);
        return;
      }

      code = getServerCartActie(item.product_id);
      if (code) {
        add(code);
        return;
      }

      var reg = registry[String(item.product_id)];
      if (reg && reg.code) {
        add(reg.code);
        return;
      }

      code = getActiveActieCode();
      if (code) add(code);
    });

    return list;
  }

  function syncProductPageForm(root) {
    root = root || document.querySelector('.uf-lf-product');
    if (!root) return;

    var productId = root.getAttribute('data-uf-lf-product-id');
    var handle = root.getAttribute('data-uf-lf-product-handle');
    var input = root.querySelector('[data-uf-lf-actie-input]');
    var code = getActiveActieCode() || getDataActieFromRoot(root);

    if (input) input.value = code || '';

    if (productId && code) registerProduct(productId, handle, code);
  }

  w.UF_LF_PRODUCT_ACTIE = {
    getActiveActieCode: getActiveActieCode,
    registerProduct: registerProduct,
    getActieFromLineItem: getActieFromLineItem,
    resolveCandidatesFromCart: resolveCandidatesFromCart,
    syncProductPageForm: syncProductPageForm
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.uf-lf-product').forEach(function (root) {
      syncProductPageForm(root);
    });
  });
})(window);
